import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, PropType, ref, watch } from 'vue';
import { ChecklistFloatField } from '@/interfaces/components/configurator/ChecklistFloatField';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { EventBus } from '@/helpers/EventBusHelper';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistFloatFieldModule',
  props: {
    checklistFloatField: { type: Object as PropType<ChecklistFloatField>, required: true },
    pId: { type: String, required: true },
    isDisabled: { type: Boolean, default: false },
    debounceToggleIsActive: {
        type: Function as PropType<(state: boolean) => void>,
        default: null,
    },
    activeProductFormId: { type: Number, default: null },
},
  emits: ['updateStoreFieldValue'],
  setup(__props, { emit }) {

const props = __props;





const value = ref<number | null>(1);

const fieldValue = computed(() => {
    if (props.activeProductFormId == null) {
        return null;
    }

    return store.getters['configurator/activeProductFormValue'](props.pId, props.activeProductFormId) as number | null;
});

function onBlur() {
    if (value.value === null) {
        onChange(1);
    }

    if (value.value !== fieldValue.value) {
        onChange(value.value);
    }

    props.debounceToggleIsActive && props.debounceToggleIsActive(false);
}

function onFocus() {
    window.setTimeout(() => {
        props.debounceToggleIsActive && props.debounceToggleIsActive(true);
    }, 200);
}

function onChange(newValue: number | null) {
    EventBus.$emit(EventBusEvents.changesInDataMade, { state: true });

    emit(EventBusEvents.updateStoreFieldValue, {
        pId: props.pId,
        value: Number(newValue),
        productFormId: props.activeProductFormId,
    });
}

onMounted(() => {
    if (props.activeProductFormId == null) {
        if (props.checklistFloatField.min < 0) {
            value.value = 0;
            return;
        }

        value.value = props.checklistFloatField.min;
    }
});

watch(
    fieldValue,
    (newValue: number | null) => {
        if (props.activeProductFormId == null) {
            return;
        }

        value.value = newValue;
    },
    { immediate: true, deep: true },
);

return { __sfc: true,props, emit, value, fieldValue, onBlur, onFocus, onChange }
}

})